import { render, staticRenderFns } from "./IndicadoresMarketplaceVendasDiaSemana.vue?vue&type=template&id=c44a1cf6&scoped=true&"
import script from "./IndicadoresMarketplaceVendasDiaSemana.vue?vue&type=script&lang=js&"
export * from "./IndicadoresMarketplaceVendasDiaSemana.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresMarketplaceVendasDiaSemana.vue?vue&type=style&index=0&id=c44a1cf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44a1cf6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
